<template>
  <div class="bank-statement-pending-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="vertical-align: sub"
          ><i class="el-icon-time"></i>Pending Statement</span
        >
      </div>
      <div>
        <div class="search-area">
          <el-button
            slot="append"
            type="success"
            icon="el-icon-plus"
            @click="addPending()"
            >Add Pending</el-button
          >
        </div>

        <el-table v-loading="loading" :data="pagedTableData" border>
          <el-table-column
            sortable
            prop="transactionDate"
            label="Date"
            width="160"
            header-align="center"
            align="right"
          >
          </el-table-column>
          <el-table-column
            sortable
            prop="relateDetail3"
            label="Member Code"
            width="130"
            header-align="center"
            align="center"
            v-if="apiMode === 'project'"
          >
          </el-table-column>
          <el-table-column
            prop="description"
            label="Description"
            width="200"
            header-align="center"
            align="left"
          >
          </el-table-column>
          <el-table-column
            prop="relateDetail1"
            label="Detail 1"
            header-align="center"
            align="left"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="relateDetail2"
            label="Detail 2"
            header-align="center"
            align="left"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="debit"
            label="Debit"
            header-align="center"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="credit"
            label="Credit"
            header-align="center"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="balance"
            label="Balance"
            header-align="center"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            sortable
            prop="currency"
            label="Currency"
            header-align="center"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              {{ scope.row.currency && scope.row.currency.toUpperCase() }}
            </template>
          </el-table-column>
          <el-table-column
            prop="reference"
            label="Reference"
            header-align="center"
            align="center"
            width="300"
          >
          </el-table-column>
          <el-table-column
            fixed="right"
            prop="uid"
            label="Action"
            header-align="center"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="removePending(scope.row.transaction_id)">Remove</el-button>

            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          class="pagination-statement"
          @size-change="setPageSize"
          @current-change="setPage"
          :current-page.sync="page"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.length"
        >
        </el-pagination>
      </div>
    </el-card>

    <el-dialog
      title="Add Pending"
      :visible.sync="dialogAddPending"
      :width="device === 'mobile' ? '95%' : '50%'"
      top="5vh"
    >
      <el-form
        :model="transaction"
        :rules="rules"
        ref="pendingForm"
      >
        <el-form-item label="Transaction ID" prop="id">
          <el-input
            placeholder="Please input transaction id"
            v-model="transaction.id"
          ></el-input
        ></el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogAddPending = false">Close</el-button>
        <el-button
          type="primary"
          @click="submitAddPending()"
          :loading="submiting"
          :disabled="submiting"
          >Confirm</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getPending, updatePending, deletePending } from "@/api/transaction";
export default {
  props: {
    ledgerID: String,
    apiMode: String,
  },
  computed: {
    device() {
      return this.$store.state.app.device;
    },
    pagedTableData() {
      return this.tableData.slice(
        this.pageSize * this.page - this.pageSize,
        this.pageSize * this.page
      );
    },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      dialogAddPending: false,
      submiting: false,
      pageSize: 20,
      page: 1,
      transaction: {
        id: "",
      },
      rules: {
        id: [
          {
            required: true,
            message: "Please input transaction id",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    setPage(val) {
      this.page = val;
    },
    setPageSize(val) {
      this.pageSize = val;
    },
    getPending() {
      getPending(this.ledgerID).then(({ result, data }) => {
        if (result) {
          this.tableData = data;
        }
      });
    },
    addPending() {
      this.dialogAddPending = true;
      this.transaction.id = "";
    },
    submitAddPending() {
      this.$refs["pendingForm"].validate((valid) => {
        if (valid) {
          this.submiting = true;
          updatePending(this.transaction.id).then(({ result }) => {
            this.submiting = false;
            if (result) {
              this.getPending()
              this.dialogAddPending = false;
            }
          });
        }
      });
    },
    removePending(transaction_id) {
      this.$confirm(
        "Are you sure you want to remove, Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => { 

          deletePending(transaction_id).then(({ result, message }) => { 
            if (result) { 
              this.getPending()
            }
          })

        }).catch(() => {
          this.$message({
            type: "info",
            message: "Remove canceled",
          });
        });
    },
  },
  mounted() {
    this.getPending();
  },
};
</script>

<style lang="scss">
.bank-statement-pending-container {
  .search-area {
    margin-bottom: 16px;
    button {
      margin-left: 10px;
    }
  }
}
</style>
